import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as HomeIcon} from "assets/img/home.svg";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function DashboardItem(props) {
    const {currentPath, selectedRetailer, currentMember} = useContext(SidebarContext);

    if (1 === currentMember?.retailers?.length) {
        // When the member only has one retailer, the General dashboard is the same as the retailer's dashboard.
        return null;
    }

    return (
        <SidebarItem
            isTopLevel
            icon={<HomeIcon />}
            to={MarketplaceRoutes.ROOT}
            selected={currentPath === MarketplaceRoutes.ROOT || currentPath === MarketplaceRoutes.RETAILER_SHOW_UNIQUE_RETAILER_ASSOCIATED(selectedRetailer?.id)}
        >
            <FormattedMessage id='sidebar.item.dashboard' />
        </SidebarItem>
    );
}

export default DashboardItem;
